export const convertFirebaseDate = (firebaseDate) => {
  const fireBaseTime = new Date(firebaseDate._seconds * 1000 + firebaseDate._nanoseconds / 1000000);

  return fireBaseTime;
};
